import { FormComponentProps } from "components/Form/components/FormComponentProps";
import { Input } from "components/Form/components/Input/Input";
import { RadioGroup } from "components/Form/components/RadioGroup/RadioGroup";

export const RadioGroupFormComponent = ({
    input,
    meta,
    fieldProps,
    fieldAttr,
}: FormComponentProps) => {
    return (
        <Input fieldProps={fieldProps} fieldAttr={fieldAttr} input={input} meta={meta}>
            <RadioGroup
                identifier={input.name}
                input={input}
                attributes={fieldAttr}
                options={fieldProps.options}
            />
        </Input>
    );
};
